import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { UserService } from "../../services/UserService";

export const userOptionsKeys = {
  all: ["userOptions"],
  options: () => [...userOptionsKeys.all, "options"],
};

export function useUserOptions(enabled = true) {
  return useQuery({
    queryKey: userOptionsKeys.options(),
    queryFn: UserService.getUserOptions,
    enabled,
    staleTime: Infinity,
  });
}

export function useUpdateUserOptions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (options) => UserService.updateUserOptions(options),
    onSuccess: (data) => {
      queryClient.setQueryData(userOptionsKeys.options(), data);
    },
  });
}
